import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '~components/header';
import Navigation from '~components/navigation';
import LawsItemPageLazy from '~routes/main/laws-item-page/lazy';
import DocsItemPageLazy from '~routes/main/docs-item-page/lazy';
import MapPageLazy from '~routes/main/covid-page/lazy';
import LawsPageLazy from '~routes/main/laws-page/lazy';
import FAQPageLazy from '~routes/main/faq-page/lazy';
import LawsDigestsPageLazy from '~routes/main/laws-digests-page/lazy';
import LawsDigestsItemPageLazy from '~routes/main/laws-digests-item-page/lazy';
import CalendarPageLazy from '~routes/main/calendar-page/lazy';
import LawsDigestsOldPageLazy from '~routes/main/laws-digests-old-page/lazy';
import LawsDigestsItemOldPageLazy from '~routes/main/laws-digests-item-old-page/lazy';
import NewsDigestsPageLazy from '~routes/main/news-digests-page/lazy';
import NewsDigestsItemPageLazy from '~routes/main/news-digests-item-page/lazy';
import UserProfile from '~routes/main/userprofile';
import NewsPageLazy from './news-page/lazy';
import NewsItemPageLazy from './news-item-page/lazy';

import { StatisticsPageLazy as StatisticsPageLazyOld } from './statistics-page-old/lazy';
import { StatisticsItemPageLazy as StatisticsItemPageLazyOld } from './statistics-item-page-old/lazy';

import StatisticsPageLazy from './statistics-page/lazy';
import StatisticsItemPageLazy from './statistics-item-page/lazy';

import ThemeReportsPageLazy from './theme-reports-page/lazy';
import ThemeReportsItemPageLazy from './theme-reports-item-page/lazy';

import NewProjectPageLazy from './new-project-page/lazy';
import RiskCardPageLazy from './risk-card-page/lazy';
import { checkUserExpirationDateExpired } from '~utils/helpers';

function Main({
    isMobile,
    userToken,
    isNewsUserLogged,
    isLawsUserLogged,
    isNewsAvailable,
    isLawsAvailable,
    ecosystemFunctions,
}) {
    const isNoScroll = window.location.href.search('/map') !== -1;
    // console.log('+++ECOSYSTEM FUNCTIONS+++', ecosystemFunctions);
    console.log('+++user is...+++', isLawsUserLogged, isLawsAvailable, userToken);
    return (
        <React.Fragment>
            <Element name="page-top" />
            <Header>
                <Navigation isMobile={isMobile} />
            </Header>
            <div className={`main${isNoScroll ? ' no-scroll' : ''}`}>
                <Switch>
                    {/* COVID MAP */}
                    {/* {isLawsUserLogged && isLawsAvailable && <Route path="/map/:token" component={MapPageLazy} />}
                    {isLawsUserLogged && isLawsAvailable && (
                        <Route path="/map" render={() => <Redirect to={`/map/${userToken}`} />} />
                    )} */}

                    {/* NEWS */}
                    {isNewsUserLogged && isNewsAvailable && <Route path="/news/:id" component={NewsItemPageLazy} />}
                    {isNewsUserLogged && isNewsAvailable && <Route path="/news" exact component={NewsPageLazy} />}

                    {/* LAWS */}
                    {isLawsUserLogged && isLawsAvailable && (
                        <Route path="/laws/:id/:token" component={LawsItemPageLazy} />
                    )}
                    {isLawsUserLogged && isLawsAvailable && <Route path="/laws/:id" component={LawsItemPageLazy} />}
                    {isLawsUserLogged && isLawsAvailable && <Route path="/laws" exact component={LawsPageLazy} />}

                    {isLawsUserLogged && isLawsAvailable && (
                        <Route path="/docs/:id/:token" component={DocsItemPageLazy} />
                    )}
                    {isLawsUserLogged && isLawsAvailable && <Route path="/docs/:id" component={DocsItemPageLazy} />}

                    {/* CALENDAR */}
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.calendar ? (
                        <Route path="/calendar" component={CalendarPageLazy} />
                    ) : null}

                    {/* LAWS DIGESTS OLD */}
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.create_digests ? (
                        <Route path="/laws-digests-old/:id/:token" component={LawsDigestsItemOldPageLazy} />
                    ) : null}
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.create_digests ? (
                        <Route path="/laws-digests-old/:id/" component={LawsDigestsItemOldPageLazy} />
                    ) : null}
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.create_digests ? (
                        <Route path="/laws-digests-old" component={LawsDigestsOldPageLazy} />
                    ) : null}

                    {/* LAWS DIGESTS */}
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.come_to_force_digests ? (
                        <Route path="/laws-digests/:id/:token" component={LawsDigestsItemPageLazy} />
                    ) : null}
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.come_to_force_digests ? (
                        <Route path="/laws-digests/:id/" component={LawsDigestsItemPageLazy} />
                    ) : null}
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.come_to_force_digests ? (
                        <Route path="/laws-digests" component={LawsDigestsPageLazy} />
                    ) : null}

                    {/* NEWS DIGESTS */}
                    <Route path="/news-digests/:id/:token" component={NewsDigestsItemPageLazy} />
                    <Route path="/news-digests/:id" component={NewsDigestsItemPageLazy} />
                    <Route path="/news-digests" component={NewsDigestsPageLazy} />

                    {/* STATISTICS */}
                    {isLawsUserLogged && isLawsAvailable && (
                        <Route path="/statistics/:id" component={StatisticsItemPageLazyOld} />
                    )}
                    {isLawsUserLogged && isLawsAvailable && (
                        <Route path="/statistics" exact component={StatisticsPageLazyOld} />
                    )}

                    {/* REPORTS */}
                    {isLawsUserLogged &&
                        isLawsAvailable &&
                        (ecosystemFunctions.download_todo_reports || ecosystemFunctions.download_essential_reports) && (
                            <Route path="/reports/:id" component={StatisticsItemPageLazy} />
                        )}
                    {isLawsUserLogged &&
                        isLawsAvailable &&
                        (ecosystemFunctions.download_todo_reports || ecosystemFunctions.download_essential_reports) && (
                            <Route path="/reports" exact component={StatisticsPageLazy} />
                        )}

                    {/* REPORTS */}
                    {isLawsUserLogged && ecosystemFunctions instanceof Object && ecosystemFunctions.theme_reports && (
                        <Route path="/theme-reports/:id" component={ThemeReportsItemPageLazy} />
                    )}
                    {isLawsUserLogged && ecosystemFunctions instanceof Object && ecosystemFunctions.theme_reports && (
                        <Route path="/theme-reports" exact component={ThemeReportsPageLazy} />
                    )}

                    {/* RISK CARD */}
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.create_risk_map ? (
                        <Route path="/risk-card" component={RiskCardPageLazy} />
                    ) : null}

                    {/* NEW PROJECT */}
                    {(isLawsUserLogged &&
                        isLawsAvailable &&
                        ecosystemFunctions instanceof Object &&
                        ecosystemFunctions.add_new_law_project) ||
                    ecosystemFunctions.edit_new_law_project ? (
                        <Route path="/new-project" component={NewProjectPageLazy} />
                    ) : null}

                    <Route path="/faq" component={FAQPageLazy} />
                    <Route path="/user" component={UserProfile} />

                    {/* REDIRECTS */}
                    {isNewsUserLogged && isNewsAvailable && <Redirect to="/news" />}
                    {isLawsUserLogged && isLawsAvailable && <Redirect to="/laws" />}
                    {!isNewsAvailable && !isLawsAvailable && <Redirect to="/user/settings" />}
                </Switch>
            </div>
        </React.Fragment>
    );
}

Main.propTypes = {
    isMobile: PropTypes.bool,
    userToken: PropTypes.string,
    isNewsUserLogged: PropTypes.bool,
    isLawsUserLogged: PropTypes.bool,
    isNewsAvailable: PropTypes.bool,
    isLawsAvailable: PropTypes.bool,
    ecosystemFunctions: PropTypes.object,
};

const mapStateToProps = (state) => ({
    isMobile: state.ui.device === 'mobile',
    userToken: state.user.ut,
    isNewsUserLogged: !checkUserExpirationDateExpired(state.user.newsUser.token_expires_at),
    isLawsUserLogged: !checkUserExpirationDateExpired(state.user.lawsUser.token_expires_at),
    isNewsAvailable: state.user.feed_settings && state.user.feed_settings.news,
    isLawsAvailable: state.user.feed_settings && state.user.feed_settings.laws,
    ecosystemFunctions: state.user.ecosystem.functions,
});

export default connect(mapStateToProps)(Main);
export { Main };



// WEBPACK FOOTER //
// ./src/routes/main/index.js